import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { post } from 'axios';
import { sumBy } from 'lodash';
import { Formik } from 'formik';
import { MDBCol, MDBRow } from 'mdbreact';

import { actionSvgs } from 'assets/icons';

import Page from 'components/PageStructure';

import FilledButton from 'components/Buttons/FilledButton';
import UnfilledButton from 'components/Buttons/UnfilledButton';

import Divider from 'components/FormGroup/Divider';
import ErrorMessage from 'components/FormGroup/ErrorMessage';
import InputField from 'components/FormGroup/InputField';
import Label from 'components/FormGroup/Label';
import SelectField from 'components/FormGroup/SelectField';
import Textarea from 'components/FormGroup/Textarea';

import Overlay from 'components/Informations/Overlay';
import Toast from 'components/Informations/Toast';

import useFetch from 'hooks/useFetch';
import endpoints from 'services/endpoints';

import { FormatCurrency } from 'utils/core';
import { formatDate } from 'utils/moment';

import * as S from './styles';
import * as U from './utils';

const {
  refundsCategoryTypes,
  RequestRefund,
  getCoustCenterOptions,
  refundFiles,
  deleteRefundFile,
  deleteRefundItem,
} = endpoints;

export default function RequestRefunds({ history, user }) {
  const { id_funcionario: idUser } = user;

  const { location, push } = history;

  const { state } = location;

  const { id_reembolso: idReembolso, itens: itensReembolso, viewType } = state;

  const {
    nome,
    key,
    date,
    nome_projeto: projeto,
    idetificacao_projeto: projetoId,
  } = state;

  const generateTempList = id => {
    const tempList = {
      _id: id,
      id_tipo_reembolso: null,
      id_item_reembolso: null,
      quantidade: null,
      valor_unitario: null,
    };
    return tempList;
  };

  const renderToast = (type, message, closeTime) => {
    const condition = closeTime !== undefined ? closeTime : toastClose;
    setToastVisibility(true);
    setToastMessage(message);
    setToastType(type);
    setToastClose(condition);

    setTimeout(() => {
      setToastVisibility(false);
      setToastMessage('');
      setToastType('');
    }, condition + 1500);
  };

  const [formAlterations, setFormAlterations] = useState(false);
  const [files, setFiles] = useState([]);
  const [totalPrice, setTotalPrice] = useState([]);
  const [overlayVisibility, setOverlayVisibility] = useState(false);
  const [overlayType, setOverlayType] = useState('');
  const [overlayAction, setOverlayAction] = useState(() => {});
  const [toastVisibility, setToastVisibility] = useState(false);
  const [toastType, setToastType] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [toastClose, setToastClose] = useState(2000);
  const [reloadFiles, setReloadFiles] = useState(false);

  const [refundsOptions, setRefundsOptions] = useState([]);
  const [savedFilesList, setSavedFilesList] = useState([]);
  const [refundsItemsList, setRefundsIntemsLit] = useState(
    itensReembolso && itensReembolso.length
      ? [...itensReembolso]
      : [generateTempList(new Date().getTime())],
  );

  const [refundsCategories] = useFetch(refundsCategoryTypes);
  const [costCenterOptions] = useFetch(getCoustCenterOptions);
  const [savedFiles] = useFetch(
    idReembolso ? `${refundFiles}/${idReembolso}` : '',
    reloadFiles,
  );

  const initialValues = U.GetInialValues(state);

  const sumTotalValues = () => item => ({
    result: item.quantidade * item.valor_unitario,
  });

  useEffect(() => {
    (async () => {
      const data = await refundsCategories;

      const refundsItems = await refundsItemsList;
      const multiples = await refundsItems.map(sumTotalValues());
      const total = await sumBy(multiples, 'result');

      setRefundsOptions(data || []);
      setTotalPrice(total);
    })();
  }, [refundsItemsList, refundsCategories]);

  useEffect(() => {
    (async () => {
      const response = await savedFiles;
      setSavedFilesList(response);
    })();
    const unMount = () => {
      setSavedFilesList([]);
    };
    return unMount;
  }, [savedFiles]);

  const costCenter = costCenterOptions.map(({ id, label }) => ({
    value: id,
    label,
  }));

  const returnToPreviousPage = () =>
    push({
      pathname:
        viewType === 'insert'
          ? '/auth/appointments/'
          : '/auth/appointments/refunds-history',
      state: { date: date || new Date() },
    });

  const renderOverlay = type => {
    switch (type) {
      case 'cancel':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="warning"
            text={[
              'Você está ',
              <span>cancelando</span>,
              ' a atualização e isso fará com que todas as informações ',
              <span>não salvas</span>,
              ' sejam ',
              <span>descartadas</span>,
              ' Deseja continuar com esta ação?',
            ]}
          >
            <UnfilledButton
              text="Sim, continuar"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
                returnToPreviousPage();
              }}
            />
            <FilledButton
              text="Não"
              buttonClass="warn"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
          </Overlay>
        );

      case 'deleteFile':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="warning"
            text={[
              'Você está ',
              <span>Removendo este comprovante de pagamento</span>,
              '. Deseja continuar?',
            ]}
          >
            <UnfilledButton
              text="Sim, continuar"
              handleClick={() => {
                overlayAction();
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
            <FilledButton
              text="Não"
              buttonClass="warn"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
          </Overlay>
        );

      case 'returning':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="warning"
            text={[
              'Você está ',
              <span>voltando para a tela anterior</span>,
              ' e esta ação irá ',
              <span>descartar</span>,
              ' as alterações que não foram salvas. Deseja continuar?',
            ]}
          >
            <UnfilledButton
              text="Sim, continuar"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
                returnToPreviousPage();
              }}
            />
            <FilledButton
              text="Não, permanecer"
              buttonClass="warn"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
          </Overlay>
        );

      case 'confirm':
        return (
          <Overlay
            isOpen={overlayVisibility}
            type="success"
            text={
              viewType === 'insert'
                ? [
                    'Você está ',
                    <span>solicitando</span>,
                    ' um novo reembolso de ',
                    <span>despesas gastas</span>,
                    ' com este projeto. Deseja continuar?',
                  ]
                : [
                    'Você está ',
                    <span>Alterando</span>,
                    ' as informações do reembolso neste projeto. Deseja salvar?',
                  ]
            }
          >
            <UnfilledButton
              text="Sim"
              handleClick={() => {
                overlayAction();
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
            <FilledButton
              text="Não"
              buttonClass="confirm"
              handleClick={() => {
                setOverlayType('');
                setOverlayVisibility(!overlayVisibility);
              }}
            />
          </Overlay>
        );

      default:
        return '';
    }
  };

  const handleSetFiles = async images => {
    setFormAlterations(true);

    const mapImages = async img => {
      const response = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        const imgInfo = img.name.split('.');
        const [name, ext] = imgInfo;
        reader.onload = () =>
          resolve({
            name,
            ext,
            _id: new Date().getTime(),
            base64: reader.result,
          });
        reader.onerror = reject;
        reader.readAsDataURL(img);
      });
      return response;
    };

    const collection = await Promise.all(images.map(mapImages));
    setFiles(prev => [...prev, ...collection]);
  };

  const deleteDroppedFiles = id => e => {
    e.stopPropagation();
    e.preventDefault();
    setFiles(prev => prev.filter(file => file._id !== id));
  };

  const handleChangeField = (field, paramId, value) => prev => {
    const filter = prev.map(item => {
      const { id_item_reembolso: idItemRefund, _id: idItem } = item;
      if (idItemRefund === paramId || idItem === paramId) {
        return {
          ...item,
          [field]: value,
        };
      }
      return item;
    });
    return filter;
  };

  const hadleDeleteListRefundItems = (item, setFieldValue) => e => {
    e.preventDefault();
    const { _id, id_item_reembolso: idRefundItem } = item;
    if (_id) {
      setRefundsIntemsLit(prev =>
        prev.filter(listItem => listItem._id !== _id),
      );
    }

    if (idRefundItem) {
      post(deleteRefundItem, {
        id_usr_up: idUser,
        id_item_reembolso: idRefundItem,
      })
        .then(() =>
          setRefundsIntemsLit(prev =>
            prev.filter(
              listItem => listItem.id_item_reembolso !== idRefundItem,
            ),
          ),
        )
        .then(() => setFieldValue('itens', refundsItemsList))
        .then(() => setFieldValue('valor_total', totalPrice))
        .catch(() =>
          renderToast(
            'error',
            'Erro ao tentar excluir este item. Por favor, tente novamente',
            3000,
          ),
        );
    }
  };

  const submitForm = async validated => {
    const mappedFiles = await files.map(file => file.base64);

    const sendData = {
      id_usr_in: idUser,
      id_usr_up: idUser,
      ...state,
      ...validated,
      date: state.dt_apontamento,
      nome: state.nome_funcionario,
      id_aprovacao: state.id_aprovacao_gestor,
      aprovacao: state.descricao_status_aprovacao_gestor,
      dt_solicitacao: state.dt_solicitacao
        ? state.dt_solicitacao
        : formatDate(new Date(), 'YYYY-MM-DD'),
      imagem: files.length ? mappedFiles : [],
      valor_total: totalPrice,
    };

    post(RequestRefund, sendData)
      .then(() => {
        renderToast(
          'success',
          viewType === 'insert'
            ? 'Solicitação de reembolso realizada com sucesso. Aguarde a análise dos responsáveis'
            : 'Alterações salvas com sucesso!',
          5000,
        );
      })
      .then(() => setFormAlterations(false))
      .then(() => setTimeout(() => returnToPreviousPage(), 5000))
      .catch(() => {
        renderToast(
          'error',
          'Erro ao solicitar reembolso, por favor verifique os dados e tente novamente',
          5000,
        );
      });
  };

  const DeleteIMAGE = imgName => () => {
    const DeleteData = {
      nome_imagem: imgName,
    };

    post(deleteRefundFile, DeleteData)
      .then(() => renderToast('success', 'Imagem removida com sucesso', 3000))
      .then(() => setReloadFiles(prev => !prev))
      .catch(() => renderToast('error', 'Erro ao deletar esta imagem', 3000));
  };

  return (
    <>
      {overlayVisibility && renderOverlay(overlayType, overlayAction)}

      {toastVisibility && (
        <Toast
          type={toastType}
          message={toastMessage}
          autoClose={toastClose}
          hideProgress
        />
      )}

      <Page
        previousPage="/auth/appointments/refunds-history"
        title="Solicitar Reembolso"
        subtitle={`${nome || projeto} | ${key || projetoId}`}
        pageAction={() => {
          const haveAlterations = () => {
            setOverlayVisibility(true);
            setOverlayType('returning');
          };

          const dontHaveAlterations = () => {
            setToastVisibility(false);
            returnToPreviousPage();
          };

          return formAlterations ? haveAlterations() : dontHaveAlterations();
        }}
      >
        <Formik
          initialValues={initialValues}
          enableReinitialize
          validateOnBlur={false}
          validateOnChange={false}
          validationSchema={U.FormValidation}
          // eslint-disable-next-line no-return-await
          onSubmit={async e => await submitForm(e)}
        >
          {({ values, errors, handleSubmit, setFieldValue, isSubmitting }) => (
            <form onSubmit={e => e.preventDefault()} noValidate>
              <MDBRow>
                <MDBCol xs="12" md="6">
                  <Divider
                    hasTopSpacing={false}
                    text="Informações desta solicitação"
                  />
                  <InputField
                    labelText="Nome do projeto (*)"
                    placeholderText="Defina o nome do projeto"
                    name="nome_projeto"
                    value={values.nome_projeto}
                    handleChange={e => {
                      setFieldValue('nome_projeto', e.target.value);
                    }}
                    width={100}
                    isDisabled
                  />
                  {!!errors.nome_projeto && (
                    <ErrorMessage message={errors.nome_projeto} />
                  )}
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol xs="12" md="3">
                  <InputField
                    labelText="Identificação do projeto (*)"
                    placeholderText="Digite o código do projeto"
                    value={values.idetificacao_projeto}
                    handleChange={e => {
                      setFieldValue('idetificacao_projeto', e.target.value);
                      setFormAlterations(true);
                    }}
                    name="idetificacao_projeto"
                    width={100}
                    isDisabled
                  />
                  {!!errors.idetificacao_projeto && (
                    <ErrorMessage message={errors.idetificacao_projeto} />
                  )}
                </MDBCol>
                <MDBCol xs="12" md="3">
                  <SelectField
                    hasLabelMargin
                    labelText="Centro de custos (*)"
                    placeholderText="Centro de custos do projeto"
                    value={costCenter.find(
                      cc => cc.value === values.id_centro_de_custo,
                    )}
                    handleChange={e => {
                      setFieldValue('id_centro_de_custo', e.value);
                    }}
                    name="id_centro_de_custo"
                    options={costCenter}
                    width={100}
                  />
                  {!!errors.id_centro_de_custo && (
                    <ErrorMessage message={errors.id_centro_de_custo} />
                  )}
                </MDBCol>
              </MDBRow>
              {refundsItemsList &&
                refundsItemsList.length &&
                refundsItemsList.map(list => (
                  <MDBCol lg="6" sm="12">
                    <MDBRow>
                      <S.DynamicBlock key={list._id}>
                        <MDBRow>
                          <MDBCol lg="12">
                            <SelectField
                              labelText="Tipo de despesa (*)"
                              options={refundsOptions}
                              placeholderText="Selecione o tipo da despesa"
                              value={refundsOptions.find(
                                item => item.value === list.id_tipo_reembolso,
                              )}
                              handleChange={e => {
                                setRefundsIntemsLit(
                                  handleChangeField(
                                    'id_tipo_reembolso',
                                    list.id_item_reembolso || list._id,
                                    parseInt(e.value),
                                  ),
                                );
                                if (e.value === 5) {
                                  setRefundsIntemsLit(
                                    handleChangeField(
                                      'valor_unitario',
                                      list.id_item_reembolso || list._id,
                                      8 / 10,
                                    ),
                                  );
                                } else {
                                  setRefundsIntemsLit(
                                    handleChangeField(
                                      'valor_unitario',
                                      list.id_item_reembolso || list._id,
                                      0,
                                    ),
                                  );
                                }
                                setFieldValue('valor_total', totalPrice);
                                setFormAlterations(true);
                              }}
                              onBlur={() => {
                                setFieldValue('itens', refundsItemsList);
                              }}
                              name="id_tipo_reembolso"
                              width={100}
                            />
                          </MDBCol>
                        </MDBRow>
                        <MDBRow className="mt-3">
                          <MDBCol lg="6" sm="12">
                            <InputField
                              labelText="Quantidade (*)"
                              placeholderText="Digite a quantidade"
                              value={list.quantidade}
                              handleChange={e => {
                                setRefundsIntemsLit(
                                  handleChangeField(
                                    'quantidade',
                                    list.id_item_reembolso || list._id,
                                    e.target.value || 0,
                                  ),
                                );
                                setFormAlterations(true);
                              }}
                              onBlur={e => {
                                setRefundsIntemsLit(
                                  handleChangeField(
                                    'quantidade',
                                    list.id_item_reembolso || list._id,
                                    e.target.value || 0,
                                  ),
                                );
                                setFieldValue('itens', refundsItemsList);
                                setFieldValue('valor_total', totalPrice);
                              }}
                              name="quantidade"
                              width={100}
                            />
                          </MDBCol>
                          <MDBCol lg="6" sm="12">
                            <InputField
                              labelText="Valor unitário (*)"
                              placeholderText="Digite o valor unitário"
                              value={list.valor_unitario}
                              disabled={list.id_tipo_reembolso === 5}
                              type="number"
                              min="00.00"
                              max="100000.00"
                              step="00.01"
                              handleChange={e => {
                                const { value } = e.target;
                                setFieldValue('itens', refundsItemsList);
                                setRefundsIntemsLit(
                                  handleChangeField(
                                    'valor_unitario',
                                    list.id_item_reembolso || list._id,
                                    value,
                                  ),
                                );
                                setFieldValue('valor_total', totalPrice);
                                setFormAlterations(true);
                              }}
                              onBlur={e => {
                                const { value } = e.target;
                                setRefundsIntemsLit(
                                  handleChangeField(
                                    'valor_unitario',
                                    list.id_item_reembolso || list._id,
                                    parseFloat(value).toFixed(2),
                                  ),
                                );
                                setFieldValue('valor_total', totalPrice);
                                setFieldValue('itens', refundsItemsList);
                              }}
                              name="valor_unitario"
                              width={100}
                            />
                          </MDBCol>
                        </MDBRow>
                        <S.Result>
                          <MDBRow>
                            <MDBCol
                              lg="12"
                              className="d-flex flex-column align-items-end justify-content-end line"
                            >
                              <S.RemoveButton
                                onClick={hadleDeleteListRefundItems(
                                  list,
                                  setFieldValue,
                                )}
                                disabled={refundsItemsList.length === 1}
                              >
                                {actionSvgs('remove')}
                                <span>Remover item</span>
                              </S.RemoveButton>

                              {!!errors.itens_reembolso && (
                                <ErrorMessage
                                  message={errors.itens_reembolso}
                                />
                              )}
                            </MDBCol>
                          </MDBRow>
                        </S.Result>
                      </S.DynamicBlock>
                    </MDBRow>
                  </MDBCol>
                ))}

              <MDBRow>
                <MDBCol
                  xs="12"
                  md="6"
                  className="d-flex flex-wrap align-content-center justify-content-between"
                >
                  <S.TotalPriceWrap>
                    {totalPrice > 0 ? (
                      <S.TotalPrice>
                        Valor total da solicitação:
                        {FormatCurrency(totalPrice)}
                      </S.TotalPrice>
                    ) : (
                      values.valor_total > 0 && (
                        <S.TotalPrice>
                          Valor total da solicitação:
                          {FormatCurrency(values.valor_total)}
                        </S.TotalPrice>
                      )
                    )}
                  </S.TotalPriceWrap>
                  <FilledButton
                    text="Adicionar item"
                    buttonClass="default"
                    buttonType="button"
                    className="d-flex flex-wrap align-content-center justify-content-between"
                    handleClick={() =>
                      setRefundsIntemsLit(prev => [
                        ...prev,
                        generateTempList(new Date().getTime()),
                      ])
                    }
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol xs="12" md="6">
                  <Textarea
                    labelText="Descrição da despesa (*)"
                    placeholderText="Detalhe aqui o seu pedido"
                    value={values.detalhamento}
                    handleChange={e => {
                      setFieldValue('detalhamento', e.target.value);
                      setFormAlterations(true);
                    }}
                    name="detalhamento"
                    width={100}
                  />
                  {!!errors.detalhamento && (
                    <ErrorMessage message={errors.detalhamento} />
                  )}
                </MDBCol>
              </MDBRow>
              {!!savedFilesList.length && (
                <MDBRow>
                  <MDBCol xs="12" md="6">
                    <S.SavedImagesContainer>
                      <S.savedFilesTitle>Comprovantes salvos</S.savedFilesTitle>
                      <S.ThumbnailsContainer>
                        {savedFilesList.map(item => (
                          <S.ThumbContainer key={item.nome}>
                            <S.ThumbImage bg={item.base64} />
                            <S.ThumbInfoContainer>
                              <S.ThumbName>
                                {item.nome.split('/')[2]}
                              </S.ThumbName>
                              <S.ThumbAction>
                                <S.RemoveButton
                                  onClick={e => {
                                    e.preventDefault();
                                    setOverlayVisibility(true);
                                    setOverlayType('deleteFile');
                                    setOverlayAction(() =>
                                      DeleteIMAGE(item.nome),
                                    );
                                  }}
                                >
                                  {actionSvgs('remove')}
                                  <span style={{ fontSize: '10px' }}>
                                    Remover comprovante
                                  </span>
                                </S.RemoveButton>
                              </S.ThumbAction>
                            </S.ThumbInfoContainer>
                          </S.ThumbContainer>
                        ))}
                      </S.ThumbnailsContainer>
                    </S.SavedImagesContainer>
                  </MDBCol>
                </MDBRow>
              )}
              <MDBRow>
                <MDBCol xs="12" md="6">
                  <Label
                    hasMargin
                    text="Anexo dos comprovantes*"
                    htmlFor="inputFiles"
                  />
                  <S.DragAndDrop onDrop={handleSetFiles} multiple>
                    {({ getRootProps, getInputProps, isDragActive }) => (
                      <S.DragDropSection>
                        <S.DragDropDiv
                          {...getRootProps()}
                          isDraging={isDragActive}
                        >
                          <input
                            name="proofOfPayment"
                            {...getInputProps()}
                            id="inputFiles"
                          />
                          {!files.length ? (
                            <S.DragAndDropStatusNull isDraging={isDragActive}>
                              <h3>Arraste os anexos</h3>
                              <p>ou clique aqui para selecioná-los</p>
                            </S.DragAndDropStatusNull>
                          ) : (
                            <S.DragedElementsContainer isDraging={isDragActive}>
                              {files.map(file => (
                                <div>
                                  <p>{file.name}</p>
                                  <S.RemoveButton
                                    type="button"
                                    {...getRootProps({
                                      onClick: deleteDroppedFiles(file._id),
                                    })}
                                  >
                                    {actionSvgs('remove')}
                                  </S.RemoveButton>
                                </div>
                              ))}
                            </S.DragedElementsContainer>
                          )}
                        </S.DragDropDiv>
                      </S.DragDropSection>
                    )}
                  </S.DragAndDrop>
                  <S.Small>
                    *Permitido apenas o anexo de imagens em formatos JPEG, JPG e
                    PNG
                  </S.Small>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol xs="12" md="6">
                  <S.FormButtonsWrap>
                    <FilledButton
                      buttonClass="cancel"
                      text="Cancelar"
                      buttonType="button"
                      handleClick={() => {
                        setOverlayVisibility(true);
                        setOverlayType('cancel');
                        setFormAlterations(true);
                      }}
                    />
                    <FilledButton
                      text={viewType === 'insert' ? 'Solicitar' : 'Salvar'}
                      buttonClass="confirm"
                      buttonType="submit"
                      disabled={isSubmitting || !formAlterations}
                      handleClick={() => {
                        setOverlayVisibility(true);
                        setOverlayType('confirm');
                        setOverlayAction(() => handleSubmit);
                      }}
                    />
                  </S.FormButtonsWrap>
                </MDBCol>
              </MDBRow>
            </form>
          )}
        </Formik>
      </Page>
    </>
  );
}

RequestRefunds.defaultProps = {
  user: {},
  history: {},
};

RequestRefunds.propTypes = {
  user: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  ),
  history: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  ),
};
